import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router'
import { ButtonToolbar, Button } from 'react-bootstrap'
import List from './../common/List'
import moment from 'moment'

class Entity extends Component {
    constructor(props) {
        super(props)
        let self = this
        this.state = {
            dataColumnsNames: [
                'Fecha', 'External Id', 'Name', 'Fee', 'Credenciales', 'Acciones'
            ],
            showModal: false,
            loading: false
        }
        self.props.actions.entityGet = self.props.actions.entityGet.bind(self, self.props.params.appCodename)
        self.props.actions.entityClean = self.props.actions.entityClean.bind(self)
        self.props.actions.refreshCredentials = self.props.actions.refreshCredentials.bind(self)
    }

    refreshCredentials(data) {
        let self = this
        return self.props.actions.refreshCredentials(self.props.params.appCodename, data).then(res => {
            window.open(res.payload.data.url)
            return Promise.resolve()
        })
    }

    dataObjectProcess(data) {
        let self = this
        let appCodename = self.props.params.appCodename
        let row = []
        var dateTime = new Date(data.createdAt)
        dateTime = moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
        let externalId = (data && data.externalId) ? data.externalId : ''
        let name = (data && data.name) ? data.name : ''
        let fee = (data && data.fee) ? data.fee : ''
        let credentials = null
        let refreshCredentials = null
        if (data && data.accessTokenExpiresAt && moment(data.accessTokenExpiresAt).isAfter(moment())) {
            credentials = (<i className="fa fa-check" aria-hidden="true"></i>)
        } else {
            credentials = (<i className="fa fa-times" aria-hidden="true"></i>)
            refreshCredentials = (<Button onClick={self.refreshCredentials.bind(self, data)} type="button" className="btn btn-default">
                <span className="fa fa-key" aria-hidden="true" ></span>
            </Button>)
        }
        row.push(
            <div>{dateTime}</div>
        )
        row.push(
            <div>{externalId}</div>
        )
        row.push(
            <div>{name}</div>
        )
        row.push(
            <div>{fee}%</div>
        )
        row.push(
            <div>{credentials}</div>
        )
        row.push(
            <ButtonToolbar>
                {refreshCredentials}
                <Link to={`/manager/${appCodename}/entity/detail/${data._id}`} type="button" className="btn btn-default">
                    <i className="fa fa-eye" aria-hidden="true"></i>
                </Link>
                <Link to={'/manager/' + self.props.params.appCodename + '/entity/' + data.externalId + '/transactions'} type='button' className='btn btn-primary' disabled={ self.state.loading }>
                    Ver transacciones
                </Link>
            </ButtonToolbar>
        )
        return row
    }

    render() {
        let self = this
        let content
        let itemsProcessed = []

        if (self.props.entities && self.props.entities.length) {
            self.props.entities.forEach(function(user) {
                itemsProcessed.push(self.dataObjectProcess(user))
            })
        }

        content = <List ref={(list) => { self.list = list }}
                    items={itemsProcessed}
                    name="Entidades"
                    dataColumnsNames={self.state.dataColumnsNames}
                    getObjects={self.props.actions.entityGet}
                    clearObjects={self.props.actions.entityClean}
                    limit={50}
                    routing={self.props.routing}/>

        return (
            <div>
                {content}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        entities: state.entities,
        profile: state.profile,
        routing: state.routing
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Entity)



// WEBPACK FOOTER //
// ./components/Entity/index.js